import { Component, DataSubscriptionProvider } from '@hatiolab/things-scene'

import gql from 'graphql-tag'
import { subscribe } from '@operato/graphql'

export class DataSubscriptionProviderImpl implements DataSubscriptionProvider {
  async subscribe(tag: string, component: Component) {
    return await subscribe(
      {
        query: gql`
                  subscription {
                    data(tag: "${tag}") {
                      tag
                      data
                    }
                  }
                `
      },
      {
        next: async ({ data }: { data: any }) => {
          if (data) {
            component.data = data.data.data
          }
        }
      }
    )
  }

  dispose() {}
}
